﻿import { Map as MaplibreMap, TerrainControl as MaplibreTerrainControl } from 'maplibre-gl';
import React, { useEffect } from 'react';
import WorkspaceItemContext from '../../app/contexts/workspace/workspace-item-context';
import { useAppDispatch } from '../../app/hooks/store-hooks';
import useMap from '../../app/hooks/use-map';
import { patchFocusedWorkspaceView } from '../../app/state/store';

export const TERRAIN_SPECIFICATION = {
    source: 'terrain_source',
    exaggeration: 1
};

class FeTerrainControl extends MaplibreTerrainControl {
    #control: HTMLElement | null = null;
    _callback: (() => void) | null = null;

    onAdd(map: MaplibreMap): HTMLElement {
        this.#control = super.onAdd(map);

        const terrainEl = this.#control.querySelector('.maplibregl-ctrl-terrain');
        terrainEl?.classList.add('k-button', 'k-button-md', 'k-button-solid', 'k-button-solid-base', 'k-rounded-md', 'k-icon-button');

        return document.createElement('div'); // map inserts empty div
    }

    getElement(): HTMLElement | null {
        return this.#control;
    }

    onRemove() {
        if (this._callback) {
            const terrainEl = this.#control?.querySelector('.maplibregl-ctrl-terrain');
            terrainEl?.removeEventListener('click', this._callback);
        }
        super.onRemove();
        this.#control = null;
    }

    setOnClick(callback: () => void) {
        const terrainEl = this.#control?.querySelector('.maplibregl-ctrl-terrain');
        this._callback = callback;
        terrainEl?.addEventListener('click', this._callback);
    }
}

export function TerrainControl() {
    const map = useMap();
    const [controlEl, setControlEl] = React.useState<HTMLElement | null>(null);
    const containerRef = React.useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const context = React.useContext(WorkspaceItemContext);

    useEffect(() => {
        if (map) {
            const control = new FeTerrainControl(TERRAIN_SPECIFICATION);
            map.addControl(control, 'bottom-left');
            control.setOnClick(() => {
                dispatch(
                    patchFocusedWorkspaceView((x) => {
                        x.map.terrain = !!map.getTerrain();
                    }, context.id)
                );
            });
            setControlEl(control.getElement());

            return () => {
                setControlEl(null);
            };
        }
    }, [map, dispatch, context.id]);

    useEffect(() => {
        if (controlEl && containerRef.current) {
            containerRef.current.appendChild(controlEl);
            return () => {
                if (containerRef.current?.contains(controlEl)) {
                    containerRef.current.removeChild(controlEl);
                }
            };
        }
    }, [controlEl]);

    return (
        <div className={'k-card d-flex flex-row gap-1 align-items-center pe-auto overflow-visible'} style={{ width: 'fit-content' }}>
            <div ref={containerRef} className={'navigation-ctrl-container2'} />
        </div>
    );
}
